const FINDINGS = {
  // main headers
  qxr: "Chest X-ray scans (qXR)",
  qer: "Brain NCCT scans (qER-Quant)",
  qct: "Chest CT Scans {qCT}",
  qmsk: "Fractures",
  forms: "Forms submitted",
  modality: "Modality",
  // group headers
  emergent_findings: "Emergent findings",
  other_findings: "Other findings",
  tags: "Tags",
  intra_cranial_hemorrhage: "Intra-cranial hemorrhage",
  // qxr
  abnormal: "Abnormal",
  atelectasis: "Atelectasis",
  bluntedcp: "Blunted costophrenic angle",
  calcification: "Calcification",
  cardiomegaly: "Cardiomegaly",
  cavity: "Cavity",
  consolidation: "Consolidation",
  degenspine: "Degenerative spine",
  diaphragm: "Diaphragm",
  fibrosis: "Fibrosis",
  hilarlymphadenopathy: "Hilar lymph adenopathy",
  nodule: "Nodule",
  opacity: "Opacity",
  peffusion: "Pleural effusion",
  pneumoperitoneum: "Pneumoperitoneum",
  reticulonodularpattern: "Reticulo nodular pattern",
  ribfracture: "Rib fracture",
  scoliosis: "Scoliosis",
  trachealshift: "Tracheal shift",
  clavicle_fracture: "Clavicle fracture",
  pneumothorax: "Pneumothorax",
  tuberculosis: "Tuberculosis",
  lung_nodule_malignancy: "High malignant nodule",
  // qer
  ASPECTS: "ASPECT Score <10",
  ATROPHY: "Cerebral atrophy",
  EDH: "Extradural hemorrhage",
  FRACTURE: "Cranial fracture",
  ICH: "Intracranial hemorrhage",
  ME: "Mass effect",
  INFARCT: "Hypdensity suggestive of infarct",
  IPH: "Intraparenchymal hemorrhage",
  IVH: "Intraventricular hemorrhage",
  MLS: "Midline shift",
  SAH: "Subarachnoid hemorrhage",
  SDH: "Subdural hemorrhage",
  TBR: "Review required (when infarct and bleed are not present)",
  // qct
  lungnodule: "Lung Nodule",
  //qmsk
  qmsk_fracture: "qMSK fracture",
  // forms
  tb_voucher: "TB Voucher",
  symptoms: "Symptoms",
  qtrack_cbnaat_clt: "Confirmatory Lab Test - CBNAAT",
  qtrack_genexpert_clt: "Confirmatory Lab Test - GeneXpert",
  risk_groups: "Risk Groups",
  nihss: "NIHSS Evaluation",
  stroke_clinical: "Clinical History of Stroke Suspects",

  CR: "CR/CX/DR/DX",
  CT: "CT",
  MR: "MRI",
};

export const GROUPEDFINDINGS = {
  qxr: {
    emergent_findings: [
      "opacity",
      "consolidation",
      "peffusion",
      "fibrosis",
      "atelectasis",
      "clavicle_fracture",
      "ribfracture",
      "pneumothorax",
      "pneumoperitoneum",
      "lung_nodule_malignancy",
    ],
    other_findings: [
      "cavity",
      "hilarlymphadenopathy",
      "diaphragm",
      "cardiomegaly",
      "calcification",
      "nodule",
      "degenspine",
      "reticulonodularpattern",
      "scoliosis",
      "trachealshift",
      "bluntedcp",
    ],
    tags: ["abnormal", "tuberculosis"],
  },
  // qer: {
  //   intra_cranial_hemorrhage: ["IPH", "SDH", "IVH", "SAH", "EDH"],
  // },
};

export default FINDINGS;
